
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class TerminationPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;
  @Prop({ type: String, default: "" }) readonly date!: string;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;
  }

  form = {
    leaving_date: this.date,
  };

  async save() {
    this.$emit("save", this.form);

    this.close();
  }

  cancel() {
    this.$emit("cancel");

    this.close();
  }

  get disabled() {
    return !this.form.leaving_date;
  }

  get title() {
    if (this.date) return this.$tc("popup.edit.title");

    return this.$tc("popup.create.title");
  }

  get description() {
    if (this.date) return this.$tc("popup.edit.description");

    return this.$tc("popup.create.description");
  }
}
